const nameCharStart = '[a-zA-Z]';
const nameChar = '[a-zA-Z0-9-]';
export const htmlElementNameWordPattern = `${nameCharStart}${nameChar}*`;
